import styled from 'styled-components'
import { Typography } from '@telavita-core/react-design-kit'
import { ReactComponent as AlertIcon } from 'static/svg/alert-icon.svg'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const FieldWrapper = styled.div`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;

  & .customSelect {
    max-width: inherit !important;

    > div {
      margin-top: 0;
    }
  }
`

export const Text = styled(Typography)`
  line-height: 20px;
  color: #898989;
  font-style: italic;
  align-self: flex-start;
`

export const CustomAlertIcon = styled(AlertIcon)`
  margin-right: 8px;
  
  path {
    width: 24px;
    height: 24px;
  }
`

export const ErrorMessageWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
`